import {
	Anchor,
	Button,
	type DefaultMantineColor,
	Flex,
	type StyleProp,
	Text,
} from '@mantine/core';
import type { ToOptions } from '@tanstack/react-router';
import type { HTMLAttributeAnchorTarget } from 'react';
import { cloneElement } from 'react';

import { LinkButton } from '@apple/ui/link/LinkButton';

import classes from './button-with-icon.module.css';

export type CustomButtonIconProps = ToOptions & {
	icon: React.ReactNode;
	text: string;
	backgroundColor?: StyleProp<DefaultMantineColor>;
	datatestId?: string;
	href?: string;
	target?: HTMLAttributeAnchorTarget;
};

export const CustomIconButton: React.FC<CustomButtonIconProps> = ({
	icon,
	text,
	backgroundColor,
	datatestId,
	href,
	target,
	...toOptions
}) => {
	const content = (
		<>
			<Flex className={classes.icon}>{icon && cloneElement(icon as React.ReactElement)}</Flex>
			<Text ta='left' lineClamp={3} className={classes.text}>
				{text}
			</Text>
		</>
	);

	return href ? (
		<Anchor target={target} href={href} underline='never'>
			<Button data-testid={datatestId} className={classes.button} bg={backgroundColor}>
				{content}
			</Button>
		</Anchor>
	) : (
		<LinkButton
			data-testid={datatestId}
			className={classes.button}
			bg={backgroundColor}
			{...toOptions}
		>
			{content}
		</LinkButton>
	);
};
